var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-setting-preferences" }, [
    _c(
      "h3",
      {
        staticClass: "email-setting-preferences__title typographies-heading-h3"
      },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.translations.preferencesTitle) + "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "email-setting-preferences__container" }, [
      _c(
        "div",
        { staticClass: "email-setting-preferences__content" },
        [
          _c("div", [
            _c("p", { staticClass: "typographies-paragraph-medium-semibold" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.translations.copyEmails.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "email-setting-preferences__description typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.translations.copyEmails.description) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("CompassSwitch", {
            attrs: {
              value: _vm.copyEmailValue,
              disabled: _vm.disableCopyEmailSwitch
            },
            on: { click: _vm.handleCopyEmailsSwitch }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "email-setting-preferences__content" },
        [
          _c("div", [
            _c("p", { staticClass: "typographies-paragraph-medium-semibold" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.translations.automaticallyAttachDocument.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "email-setting-preferences__description typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.translations.automaticallyAttachDocument.description
                    ) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("CompassSwitch", {
            attrs: {
              value: _vm.automaticallyAttachDocumentValue,
              disabled: _vm.disableAutomaticallyAttachDocumentSwitch
            },
            on: { click: _vm.handleAutomaticallyAttachDocumentSwitch }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.privateEmailPermissions
        ? _c(
            "div",
            { staticClass: "email-setting-preferences__content" },
            [
              _c("div", [
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.translations.privateEmails.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "email-setting-preferences__description typographies-paragraph-medium-regular"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.translations.privateEmails.description) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("CompassSwitch", {
                attrs: {
                  value: _vm.privateEmailValue,
                  disabled: _vm.disablePrivateEmailSwitch
                },
                on: { click: _vm.handlePrivateEmailSwitch }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }